export default "__VITE_ASSET__Dt2_ww8N__"